module.exports = __webpack_public_path__ + "media/images/sections/home/bride_gr-858ff2dc2eb5eae53dd6baf591702cce.png";